import { Injectable } from '@angular/core';

export interface TreeDrillCacheEntry {
  mine: string;
  apiUrl: string;
  active?: string;
  response: any;
  timestamp: number;
}

@Injectable({
  providedIn: 'root'
})
export class TreeDrillCacheService {
  private cache = new Map<string, TreeDrillCacheEntry>();
  private cacheTimeout = 30 * 60 * 1000; // 30 minutes

  getCacheKey(mine: string, apiUrl: string, active = ''): string {
    return `${mine}|${apiUrl}|${active}`;
  }

  get(mine: string, apiUrl: string, active = ''): any | null {
    const key = this.getCacheKey(mine, apiUrl, active);
    const entry = this.cache.get(key);

    if (!entry) {
      return null;
    }

    // Check if cache has expired
    if (Date.now() - entry.timestamp > this.cacheTimeout) {
      this.cache.delete(key);
      return null;
    }

    return entry.response;
  }

  set(mine: string, apiUrl: string, response: any, active = ''): void {
    const key = this.getCacheKey(mine, apiUrl, active);
    this.cache.set(key, {
      mine,
      apiUrl,
      active,
      response,
      timestamp: Date.now()
    });
  }

  clear(mine?: string): void {
    if (mine) {
      // Clear all entries for a specific mine
      const keysToDelete: string[] = [];
      this.cache.forEach((entry, key) => {
        if (entry.mine === mine) {
          keysToDelete.push(key);
        }
      });
      keysToDelete.forEach(key => this.cache.delete(key));
    } else {
      // Clear everything
      this.cache.clear();
    }
  }
}
